var stylePropertyPrefixes = {
  margin: 'm',
  marginTop: 'mt',
  marginRight: 'mr',
  marginBottom: 'mb',
  marginLeft: 'ml',
  marginX: 'mx',
  marginY: 'my',
  padding: 'p',
  paddingTop: 'pt',
  paddingRight: 'pr',
  paddingBottom: 'pb',
  paddingLeft: 'pl',
  paddingX: 'px',
  paddingY: 'py',
  backgroundColor: 'bgc',
  backgroundShort: 'bgShort',
  bgShort: 'bg-short',
  visuallyHidden: 'visually-hidden',
  srOnly: 'sr-only',
  textAlign: 'text',
  textColor: 'text',
  textAllCaps: 'text-all-caps',
  fontWeight: 'font-weight',
  fontSize: 'text',
  fontFamily: 'font',
  darkMode: 'dark-mode',
  lightMode: 'light-mode',
  removeLinkStyles: 'remove-link-styles'
};
var stylePropertyValueAliases = {
  fontSize: {
    '-1': 'm1',
    '-2': 'm2'
  }
};
var styleValidProperties = new Set([// Spacing
'margin', 'm', 'marginTop', 'mt', 'marginRight', 'mr', 'marginBottom', 'mb', 'marginLeft', 'ml', 'marginX', 'mx', 'marginY', 'my', 'padding', 'p', 'paddingTop', 'pt', 'paddingRight', 'pr', 'paddingBottom', 'pb', 'paddingLeft', 'pl', 'paddingX', 'px', 'paddingY', 'py', // Background
'backgroundColor', 'bgc', 'backgroundShort', 'bgShort', // Typography
'textAlign', 'textAllCaps', 'textColor', 'fontWeight', 'fontFamily', 'fontSize', // Misc
'display', 'darkMode', 'lightMode', 'removeLinkStyles', 'srOnly', 'visuallyHidden']);
var responsiveModifierSet = new Set(['xs', 'sm', 'md', 'lg', 'xl']);

function isValidStyleProperty(key) {
  return styleValidProperties.has(key);
}

function isResponsiveModifier(key) {
  return responsiveModifierSet.has(key);
}

function getKey(key) {
  if (isValidStyleProperty(key)) {
    return stylePropertyPrefixes[key] || key;
  }

  return null;
}

var swanStyleObjectFitValues = ['cover', 'contain', 'none', 'unset', 'fill'];

function swanStyleObjectFit(value) {
  if (!value) return null;
  return "swan-image-fit-".concat(value);
}

export { getKey, isResponsiveModifier, isValidStyleProperty, responsiveModifierSet, stylePropertyPrefixes, stylePropertyValueAliases, styleValidProperties, swanStyleObjectFit, swanStyleObjectFitValues };